import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5 9.63672H10M15 9.63672H10M10 9.63672V17.9701",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "bevel"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.833984 6.71875L1.66732 13.3854H2.91732M6.25065 13.3854H5.41732M2.91732 13.3854L2.08398 17.9687M2.91732 13.3854H5.41732M5.41732 13.3854L6.25065 17.9687",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18.75 6.71875L17.9167 13.3854H16.6667M13.3333 13.3854H14.1667M16.6667 13.3854L17.5 17.9687M16.6667 13.3854H14.1667M14.1667 13.3854L13.3333 17.9687",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.0833 7.55339C12.0833 6.4028 11.1506 5.47006 10 5.47006M7.91667 7.55339C7.91667 6.4028 8.84941 5.47006 10 5.47006M10 5.47006V4.63672M7.5 7.97006H12.5",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "bevel"
    }, null, -1)
  ]))]))
}
export default { render: render }